import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
    getUSVCalendarApi,
    getUSVDictTreeApi,
    getUSVByDateApi,
    getUSVByIdApi,
    getUSVActivityDataApi,
    postUSVCommentApi,
    putUSVCommentApi,
    postUSVActivityDataApi,
} from 'api'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    calendarInfo: null, // 被点击的日历信息
    calendarData: null, // 日历上当前范围内显示的总结填写信息
    dictData: null, // 数据字典
    listData: null, // 回显数据
    locationName: '', // location 名称
    locationId: '', // location id
    save: false,
    id: '',
}

/* 获取日历上的数据 */
export const getUSVCalendarAction = createAsyncThunk('USVSlice/getUSVCalendarAction', async (params, thunkAPI) => {
    try {
        const { data } = await getUSVCalendarApi(params)
        return data.data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

/* 获取数据字典 */
export const getUSVDictDataAction = createAsyncThunk('USVSlice/getUSVDictDataAction', async (dictType, thunkAPI) => {
    const nameDataDict = getUSVDictTreeApi(dictType[0])
    const activityTypeDataDict = getUSVDictTreeApi(dictType[1])
    return Promise.all([nameDataDict, activityTypeDataDict])
        .then(dictData => dictData)
        .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
})

/* 通过日期获取 id */
export const getUSVByDateAction = createAsyncThunk('USVSlice/getUSVByDateAction', async (listDataParams, thunkAPI) => {
    try {
        const commentData = await getUSVByDateApi(listDataParams) // 通过日期查询 id
        return commentData?.data?.data?.id
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

/* 获取数据 */
export const getUSVDataAction = createAsyncThunk('USVSlice/getUSVDataAction', async (id, thunkAPI) => {
    const commentData = getUSVByIdApi(id) // 通过 id 查询
    const activityData = getUSVActivityDataApi(id)
    return Promise.all([commentData, activityData])
        .then(listData => listData)
        .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
})

/* 保存数据 */
export const postUSVDataAction = createAsyncThunk(
    'USVSlice/postUSVDataAction',
    async ({ id, commentParams, activityParams }, { dispatch }) => {
        let vid
        try {
            if (!id) {
                const commentData = await postUSVCommentApi(commentParams) // 新增
                vid = commentData.data.data.id
                await postUSVActivityDataApi(activityParams, vid)
                dispatch(USVSlice.actions.addId(vid))
                return { isTrue: true, id: vid } // 已保存状态
            } else {
                vid = id
                await putUSVCommentApi(commentParams, id) // 修改
                await postUSVActivityDataApi(activityParams, id)
                return { isTrue: true, id } // 已保存状态
            }
        } catch (error) {
            dispatch(USVSlice.actions.addId(vid))
            dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

export const USVSlice = createSlice({
    name: 'USVSlice',
    initialState,
    reducers: {
        /* 日历点击信息 */
        addCalendarInfo: (state, action) => {
            state.calendarInfo = action.payload
        },
        /* 清空日历与详情页信息 */
        clearListData: state => {
            state.listData = null
            state.calendarData = null
            state.save = false
            state.id = ''
        },
        /* 当前日历主 id */
        addId: (state, action) => {
            state.id = action.payload
        },
        /* location 名称 */
        addLocationName: (state, action) => {
            state.locationName = action.payload
        },
        /* location id */
        addLocationId: (state, action) => {
            state.locationId = action.payload
        },
    },
    extraReducers: {
        /* 获取日历上的数据 */
        [getUSVCalendarAction.fulfilled.type]: (state, action) => {
            state.calendarData = action.payload
        },

        /* 处理数据字典 */
        [getUSVDictDataAction.fulfilled.type]: (state, action) => {
            state.dictData = action.payload
        },

        /* 提交总结数据 */
        [postUSVDataAction.fulfilled.type]: (state, action) => {
            state.save = action.payload
        },

        /* 获取回显数据 */
        [getUSVDataAction.fulfilled.type]: (state, action) => {
            state.listData = action.payload
        },

        /* 通过日期，获取 id */
        [getUSVByDateAction.fulfilled.type]: (state, action) => {
            state.id = action.payload
        },
    },
})
